import React from "react";
import { Box, Typography, Button } from "@mui/material";
import SEO from "../components/SEO";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Something went wrong." };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          textAlign="center"
          p={3}
          gap={2}
        >
          <SEO title="Something went wrong" description="An unexpected error occurred." />
          <Typography variant="h4" fontWeight={800} color="primary">
            Something went wrong
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {this.state.message}
          </Typography>
          <Button variant="contained" size="large" onClick={this.handleReload} sx={{ borderRadius: 2 }}>
            Reload
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
